class MediaUrlProcessor {
    _mediaDownloaderDomain;

    constructor(mediaDownloaderDomain) {
        this.mediaDownloaderDomain = mediaDownloaderDomain;
    }

    getPreviewUrl(url, signatureOptions) {
        if (url.includes('?__sig=') || url.includes('&__sig=')) {
            return url;
        }

        const { expires, signature } = signatureOptions || {};

        if (signature) {
            return `https://${this.mediaDownloaderDomain}/get?uri=${encodeURIComponent(
                url
            )}&__sig=${encodeURIComponent(signature)}&__expires=${expires}`;
        }

        return url;
    }

    getDownloadableUrl(link, signatureOptions) {
        try {
            const url = new URL(link);

            if (url.searchParams.get('__sig')) {
                return link;
            }

            url.searchParams.append('dl', '1');

            if (url.searchParams.get('efg')) {
                const filename = this._getFilename(url.pathname);
                if (filename) {
                    const { expires, signature } = signatureOptions || {};
                    if (signature) {
                        return `https://${this.mediaDownloaderDomain}/get?uri=${encodeURIComponent(
                            link
                        )}&filename=${encodeURIComponent(filename)}&__sig=${encodeURIComponent(
                            signature
                        )}&__expires=${expires}&referer=https%3A%2F%2Fwww.instagram.com%2F`;
                    }
                }
            }

            return url.toString();
        } catch {
            if (link.includes('?__sig=') || link.includes('&__sig=')) {
                return link;
            }

            if (!link.includes('?')) {
                return `${link}?dl=1`;
            }

            return `${link}&dl=1`;
        }
    }

    _getFilename(pathname) {
        const matches = pathname.match(/([\w-]+\.(?:jpg|mp4))$/i);
        return matches ? matches[1] : '';
    }
}

const mediaUrlProcessor = new MediaUrlProcessor('media.ssyoutube.to')
export default mediaUrlProcessor
